import { EXCEPTION_STATUS, EXCEPTION_TYPE } from './ELDConstants';

export const EXCEPTION_TYPES = {
  [EXCEPTION_STATUS.AD]: {
    abbreviation: 'AD',
    exception: 'Adverse Driving Conditions',
  },
  [EXCEPTION_STATUS.SH]: {
    abbreviation: '16',
    exception: '16-Hour Short Haul',
  },
};

export const PENDING_TYPES = {
  [EXCEPTION_TYPE.ADVERSE_DRIVING]: {
    abbreviation: 'AD',
    exception: 'Adverse Driving Conditions',
  },
  [EXCEPTION_TYPE.SIXTEEN_HOUR]: {
    abbreviation: '16',
    exception: '16-Hour Short Haul',
  },
};
